import { QuizQuestion } from './quizEngine';
import { ethereumSolidityQuestions } from './banks/ethereumSolidity';
import { cantonDamlQuestions } from './banks/cantonDaml';
import { solanaAnchorQuestions } from './banks/solanaAnchor';
import { bitcoinQuestions } from './banks/bitcoin';
import { starknetCairoQuestions } from './banks/starknetCairo';

export interface TechQuizDef {
    /** Stable identifier used in the route and the attempt API. */
    slug: string;
    /** Public route path. */
    path: string;
    /** Page title, e.g. "Ethereum & Solidity Quiz". */
    title: string;
    /** Short topic name, e.g. "Ethereum & Solidity". */
    topic: string;
    /** Matching Academy skill-tree track slug (see skillTreeData `academyTracks`). */
    trackSlug: string;
    questions: QuizQuestion[];
}

export const TECH_QUIZZES: TechQuizDef[] = [
    {
        slug: 'ethereum-solidity',
        path: '/ethereum-solidity-quiz',
        title: 'Ethereum & Solidity Quiz',
        topic: 'Ethereum & Solidity',
        trackSlug: 'ethereum-evm',
        questions: ethereumSolidityQuestions,
    },
    {
        slug: 'canton-daml',
        path: '/canton-daml-quiz',
        title: 'Canton & DAML Quiz',
        topic: 'Canton & DAML',
        trackSlug: 'canton-daml',
        questions: cantonDamlQuestions,
    },
    {
        slug: 'solana-anchor',
        path: '/solana-anchor-quiz',
        title: 'Solana & Anchor Quiz',
        topic: 'Solana & Anchor',
        trackSlug: 'solana-and-anchor',
        questions: solanaAnchorQuestions,
    },
    {
        slug: 'bitcoin',
        path: '/bitcoin-quiz',
        title: 'Bitcoin Quiz',
        topic: 'Bitcoin',
        trackSlug: 'bitcoin',
        questions: bitcoinQuestions,
    },
    {
        slug: 'starknet-cairo',
        path: '/starknet-cairo-quiz',
        title: 'Starknet & Cairo Quiz',
        topic: 'Starknet & Cairo',
        trackSlug: 'starknet-cairo',
        questions: starknetCairoQuestions,
    },
];

export const TECH_QUIZ_SLUGS = TECH_QUIZZES.map((q) => q.slug);

export const getTechQuiz = (slug: string | undefined): TechQuizDef | undefined =>
    TECH_QUIZZES.find((q) => q.slug === slug);

export const getTechQuizByTrack = (trackSlug: string | undefined): TechQuizDef | undefined =>
    TECH_QUIZZES.find((q) => q.trackSlug === trackSlug);
